/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpRoleAndPrincipalOperationEnum } from './gcpRoleAndPrincipalOperationEnum';


export interface ModifyImagePrincipalSpec { 
    /**
     * Image Name
     */
    image_name: string;
    operation: GcpRoleAndPrincipalOperationEnum;
    /**
     * Principal to add/remove based on operation
     */
    principal: Array<string>;
}
export namespace ModifyImagePrincipalSpec {
}


